module.exports = __webpack_public_path__ + "static/img/03-04.f2918095.png";